import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import DimensionItemsCell from './DimensionItemsCell';
import { getPartners } from '../selectors';

const SourcesCell = ({ key, partners, baseSourceNames, operator, ...props }) => {
    const formattedPartners = partners.map(partner => ({
        ...partner,
        icon: partner.logoPath,
    }));
    const dimensionSources =
        formattedPartners?.filter(source => baseSourceNames.some(name => source.name === name)) || [];

    return (
        <DimensionItemsCell
            key={key}
            allItems={formattedPartners}
            dimensionItems={dimensionSources}
            itemType="SOURCES"
            operator={operator}
            {...props}
        />
    );
};

SourcesCell.propTypes = {
    key: PropTypes.string.isRequired,
    partners: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            displayName: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
        })
    ),
    baseSourceNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    operator: PropTypes.string.isRequired,
};

export default connect(state => ({
    partners: getPartners(state),
}))(SourcesCell);
